import { render, staticRenderFns } from "./SafeGas.vue?vue&type=template&id=b7b82d0c&"
import script from "./SafeGas.vue?vue&type=script&lang=js&"
export * from "./SafeGas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports